<div class="__wrap  c-local-search-field-wrap" [style.max-width.px]="maxWidth()">

  <button
    *ngIf="control.value"
    type="button"
    (click)="control.setValue('')"
    mat-icon-button
    class="__clear-button">
    <mat-icon class="__clear-icon">close</mat-icon>
  </button>

  <mat-form-field
    [color]="'accent'"
    appearance="outline"
    class="__search"
    [class.has-value]="!!control.value">

    <mat-icon matPrefix>search</mat-icon>

    <input
      #searchField
      type="text"
      matInput
      [name]="name"
      autocomplete="disabled"
      [placeholder]="placeholder"
      [formControl]="control"
    />

  </mat-form-field>

</div>
